import { render } from "./ScoreMOCK2.vue?vue&type=template&id=692874fe&scoped=true"
import script from "./ScoreMOCK2.vue?vue&type=script&lang=js"
export * from "./ScoreMOCK2.vue?vue&type=script&lang=js"

import "./ScoreMOCK2.vue?vue&type=style&index=0&id=692874fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692874fe"]])

export default __exports__